import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import PageHeaderWithSearchBar from '@/components/common/Header/PageHeaderWithSearchBar.vue'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import ListContainer from '@contact/containers/ListContainer.vue'
import { mapGetters, mapMutations } from 'vuex'
import * as contactTypes from '@contact/store/types'
import * as types from '@/store/types'
import { createEventBus, removeEventBus } from '@/modules/@appbase/util'
@Component({
    components: { PageHeaderWithActionBar, PageHeaderWithSearchBar, PageViewHeaderWithActionBar, ListContainer },
    computed: {
        ...mapGetters({
            selectionList: contactTypes.CONTACT_SELECTION,
            currentPage: types.CURRENT_PAGE
        })
    },
    methods: {
        ...mapMutations({
            selectListClear: contactTypes.CONTACT_SELECT_CLEAR,
            setCurrentPage: types.CURRENT_PAGE
        })
    }
})
export default class ListView extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    searchMode: boolean = false
    
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectionList!: string[]
    currentPage!: object

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    selectListClear!: () => void
    setCurrentPage!: (page: object) => void

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get selectionCount() {
        return this.selectionList.length
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    deleteItem() {
        (this.$refs.listContainer as any).deleteItem(this.selectionList)
    }

    selectAll() {
        (this.$refs.listContainer as any).selectAll()
    }

    handleBackRequest() {
        this.selectListClear()
    }

    @Watch('$route.query.id')
    onChangedId(id: string) {
        var currentPage = {
            name : this.$t('연락처').toString()
        }
        if (!id) this.setCurrentPage(currentPage)
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        createEventBus(window, 'header-back', this.handleBackRequest)

        const id = this.$route.query.id as string
        this.onChangedId(id)
    }

    beforeDestroy() {
        removeEventBus(window, 'header-back', this.handleBackRequest)
    }
}
